import React from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import RescheduleMessage from './RescheduleMessage';
import { actionsType } from 'config/constants';

const ModalReschedule = () => {

    const closeRescheduleMessage = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.RESCHEDULE_ALERT_CLOSE),0);
    }

    return (
        <Modal customClass='modal-reschedule-alert' actionOpen={actionsType.MODAL.RESCHEDULE_ALERT_OPEN} actionClose={actionsType.MODAL.RESCHEDULE_ALERT_CLOSE}>
            <h3 className="new-modal-title">Reprograma tu pedido</h3>
            <RescheduleMessage closeRescheduleMessage={closeRescheduleMessage} />
        </Modal>
    );
}

export default ModalReschedule;
